import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Spectrumservices() {
  return (
    <section className="spectrum_services dubai_services p-100">
      <Container>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <h2>Business Empowering App Development Company in UAE</h2>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <p>
              With years of empowering startups and well-entrenched brands
              through advanced app development solutions, we caught the
              attention of several credible platforms worldwide (Zawya & Lovin
              Dubai in Dubai) while getting recognition in the mobile app
              development industry. Today, we're an end-to-end mobile app
              development solution provider with highly talented individuals
              that are primed to take your mobile app development project to the
              next level.
            </p>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="spec_services_box">
              <div className="spec_services_img">
                <StaticImage
                  src="../../images/location_new/uk-mobile/services/android.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={69}
                  height={69}
                />
              </div>
              <div className="spec_services_head">
                <h5>
                  Android App Development <br />
                  Services
                </h5>
              </div>
              <p>
                Our expert mobile app developers in Dubai specialize in creating
                high-quality Android applications to bridge the gap between you
                and your customers. With best-in-class technologies and industry
                best practices, we ensure seamless performance and intuitive
                user interfaces. Whether you require native Android development
                or cross-platform solutions using Flutter, our team delivers
                exceptional results that elevate your brand presence and drive
                user engagement.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="spec_services_box">
              <div className="spec_services_img">
                <StaticImage
                  src="../../images/location_new/uk-mobile/services/apple.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={69}
                  height={69}
                />
              </div>
              <div className="spec_services_head">
                <h5>
                  iOS App Development <br />
                  Services
                </h5>
              </div>
              <p>
                Build the mobile application that your user loves with our
                full-scale iOS app development company in Dubai. Our skilled app
                developers in Dubai design sleek and user-friendly iOS
                applications using Swift and Objective-C. We prioritize user
                experience and functionality to make your app stand out in the
                competitive App Store market. From concept design to final
                deployment, we guide you through each step for a successful
                launch and long-term success for your iOS app.
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="spec_services_box">
              <div className="spec_services_img">
                <StaticImage
                  src="../../images/locationgcc/dubai_new/dubai_game_icon.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={72}
                  height={72}
                />
              </div>
              <div className="spec_services_head">
                <h5>
                  Game App Development <br />
                  Services
                </h5>
              </div>
              <p>
                Venture into the gaming industry with confidence with our game
                app development company in Dubai. Our experienced team
                specializes in creating captivating gaming experiences, from
                casual games to immersive AR/VR applications. Using Unity and
                Unreal Engine, we develop engaging gameplay mechanics, stunning
                visuals, and seamless user interfaces that keep players engaged
                and coming back for more. Let us bring your gaming ideas to life
                and create a memorable user experience
              </p>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
            <div className="spec_services_box">
              <div className="spec_services_img">
                <StaticImage
                  src="../../images/locationgcc/dubai_new/custom_dubai_icon.webp"
                  alt="TekRevol"
                  layout="constrained"
                  placeholder="blurred"
                  formats={["webp"]}
                  width={72}
                  height={72}
                />
              </div>
              <div className="spec_services_head">
                <h5>
                  Custom App Development <br />
                  Services
                </h5>
              </div>
              <p>
                Upscale the digital potential of your business with our custom
                app development services in Dubai tailored to your target
                market. Whether you need enterprise-grade applications, IoT
                integrations, or robust e-commerce platforms, we have the
                expertise to deliver customized solutions that align with your
                goals. With collaborative and agile approach, we understand your
                business needs and deliver on-demand mobile application
                development solutions in UAE to drive your business ahead of
                competition.
              </p>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Spectrumservices;
